import { Grid, Stack, Typography } from "@mui/material"

import type { TakeawayCartItem, TakeawayProduct, TakeawayProductGroup as TakeawayProductGroupType } from "../takeawayTypes"

import { TakeawayProductCard } from "./TakeawayProductCard"

type TakeawayProductGroupProps = Readonly<{
    group: TakeawayProductGroupType
    getCartItem: (productId: number) => TakeawayCartItem | undefined
    favoriteIds: ReadonlySet<number>
    searchRegex?: RegExp
    onQuantityChange: (product: TakeawayProduct, quantity: number) => void
    onFavoriteToggle: (product: TakeawayProduct, makeFavorite: boolean) => Promise<boolean>
    onDetailsClick: (product: TakeawayProduct) => void
}>

export function TakeawayProductGroup({
    group,
    getCartItem,
    favoriteIds,
    searchRegex,
    onQuantityChange,
    onFavoriteToggle,
    onDetailsClick,
}: TakeawayProductGroupProps) {
    return (
        <Stack gap="1.5rem" id={`group-${group.id}`}>
            <Typography variant="h6">{group.name}</Typography>
            <Grid container gap="1.5rem" alignItems="stretch">
                {group.products.map((product) => {
                    const cartItem = getCartItem(product.id)
                    return (
                        <TakeawayProductCard
                            key={product.id}
                            product={product}
                            quantity={cartItem?.quantity ?? 0}
                            isFavorite={favoriteIds.has(product.id)}
                            searchRegex={searchRegex}
                            onQuantityChange={onQuantityChange}
                            onFavoriteToggle={onFavoriteToggle}
                            onDetailsClick={onDetailsClick}
                        />
                    )
                })}
            </Grid>
        </Stack>
    )
}
